import styled from 'styled-components';
import { Dimensions } from '@99designs/browser';

interface ArtboardProps {
    artboardSize: Dimensions;
}

// An "Artboard" reserves space to place an image and other annotations into using absolute positioning
const Artboard = styled.div<ArtboardProps>`
    position: relative;
    width: ${({ artboardSize: { width } }) => width}px;
    height: ${({ artboardSize: { height } }) => height}px;
`;

export default Artboard;
